import styled from "@emotion/styled";
import sparkleSVG from "assets/images/sparkles.svg";

const size = "min(95px, 15%)";
const Sparkles = styled.div({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  minHeight: 120,
  background: `5% 5% / ${size} no-repeat url(${sparkleSVG}),
               100% 100% / ${size} no-repeat url(${sparkleSVG})`,
});

export { Sparkles };
